import axios from "./axios";

export default {
    getGeneralLedgerByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getledger',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getDiaryByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getdiary',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getGeneralBalance(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getgeneralbalance',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return new Promise( ( resolve, reject ) => {
            axios(options)
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject(error )
                } );
        } ) ;
    },
    getVerificationBalance(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getverificationbalance',
            headers: { 'content-type': 'application/json' },
            params: data,
            timeout: 180000 // 3 minutos en milisegundos   
        };
        return new Promise( ( resolve, reject ) => {
            axios(options)
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject(error )
                } );
        } ) ;
    },
    sendVerificationBalanceJob(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getverificationbalance-job',
            headers: { 'content-type': 'application/json' },
            params: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data);
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message
                        });
                    }
                })
        });
    },
    getVerificationBalanceJobStatus(jobId) {
        const options = {
            method: 'GET',
            url: `/accountingreports/getverificationbalance-job/${jobId}`,
            headers: { 'content-type': 'application/json' },
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data);
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message
                        });
                    }
                })
        });
    },
    getVerificationBalanceAnnex(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getverificationbalanceannex',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return new Promise( ( resolve, reject ) => {
            axios(options)
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject(error )
                } );
        } ) ;
    },
    getSalesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getsales',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getSalesHotelBookByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getsaleshotelbook',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return axios(options);
    },
    getSalesTaxpayer(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvsalestaxpayer',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getFinalConsumer(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvfinalconsumer',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getFinalConsumerExcelData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getfinalconsumerexceldata',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getCancelDocument(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvcanceldocument',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getWithholdingVoucherReceipts(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvwithholdingreceipts',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getMassiveWithholdingCertificates(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcvsmassivewithholdingcertificates',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        // console.log(options)
        return axios(options);
    },
    getMassiveBillingInvoices(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcvsmassivebillinginvoices',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return axios(options);
    },
    getMassiveWithholdingMadeToDeclarant(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcvsmassivewithholdingmadetodeclarant',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return axios(options);
    },

    getPerception(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvperception',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getAdvanceAccount(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvadvancedAccount',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getPurchases(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvpurchases',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    
    getMassiveExpensesEntries(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getcsvmassiveexpensesEntries',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    
    getPurcharsesExcludedSubject(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurcharsesxcludedsubject',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getPurchasesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurchases',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getPurchasesByDateMHFormat(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurchasesmhformat',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getPurchasesBookExcelData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurchasesbookexceldata',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getFilterSalesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getFiltersales',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getSearchSalesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getSearchSales',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return axios(options);
    },
    getFilterPurchasesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getFilterpurchases',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        console.log(options)
        return axios(options);
    },
    getPurchaseOrderDateYears() {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurchaseorderdateyears',
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    if(response === undefined){
                        reject('No se obtuvo respuesta del servidor');
                    }
                    else if(response.data.success){
                        resolve(response.data);
                    }else{
                        reject(response.data);
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getPurchaseOrderDateMonths(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getpurchaseorderdatemonths',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    if(response === undefined){
                        reject('No se obtuvo respuesta del servidor');
                    }
                    else if(response.data.success){
                        resolve(response.data);
                    }else{
                        reject(response.data);
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getSalesDateYears() {
        const options = {
            method: 'GET',
            url: '/accountingreports/getsalesdateyears',
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    if(response === undefined){
                        reject('No se obtuvo respuesta del servidor');
                    }
                    else if(response.data.success){
                        resolve(response.data);
                    }else{
                        reject(response.data);
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getSalesDateMonths(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getsalesdatemonths',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    if(response === undefined){
                        reject('No se obtuvo respuesta del servidor');
                    }
                    else if(response.data.success){
                        resolve(response.data);
                    }else{
                        reject(response.data);
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getJournalData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getJournalData',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getGeneralJournalData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getGeneralJournalData',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getGeneralDetailJournalData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getGeneralDetailJournalData',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getGeneralLedgerData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getGeneralLedgerData',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    async getAccountingDetailData(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getAccountingDetailData',
            headers: {'content-type': 'application/json'},
            params: data
        };

        const result = await axios(options);

        const { success } = result.data;

        if (success) {
            return result.data.data;
        } else {
            throw new Error(result.data.message || 'Error al obtener los datos de detalle contable');
        }
    },
    async getAccountingDetailDataByAccounts(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getAccountingDetailDataByAccounts',
            headers: {'content-type': 'application/json'},
            params: data
        };

        const result = await axios(options);
        
        const { success } = result.data;

        if (success) {
            return result.data.data;
        } else {
            throw new Error(result.data.message || 'Error al obtener los datos de detalle contable');
        }
    },
    async getAccountingDetailDataConsolidated(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getAccountingDetailDataConsolidated',
            headers: {'content-type': 'application/json'},
            params: data,
            timeout: 180000
        };

        try {
            const result = await axios(options);
            const { success } = result.data;

            if (success) {
                return result.data.data;
            }

            throw new Error(result.data.message || 'Error al obtener los datos del libro auxiliar consolidado');
        } catch (error) {
            if (error?.response?.data?.message) {
                throw new Error(error.response.data.message);
            }

            throw error;
        }
    },
    getResultsStatement(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/getresultsstatement',
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getTotalsSalesPurchasesByDate(data) {
        const options = {
            method: 'GET',
            url: '/accountingreports/gettotalssalespurchases',
            headers: { 'content-type': 'application/json' },
            params: data
        };
        return axios(options);
    }
};
